import { useField } from 'react-final-form';
import { FdjCaseType } from '../fdjDemandTypes';

export const useFdjCaseTypeFormValue = () => {
  const caseTypeField = useField('caseType', { subscription: { value: true } });
  return {
    value: caseTypeField.input.value as FdjCaseType | undefined,
  };
};
